import { Link } from "react-router-dom";
import { ArrowRight, UserCheck, ShieldCheck, Droplets, TrendingUp, LineChart, Sunrise, Users, Layers } from "lucide-react";
import { Container, PageFade, Reveal } from "../components/site/Motion";
import { PageHeader, TopicGrid } from "../components/site/Sections";
import { ConsultationSection } from "../components/site/ConsultationSection";

const TOPICS = [
  { icon: UserCheck, t: "Protection du dirigeant" }, { icon: ShieldCheck, t: "Protection des revenus" },
  { icon: Droplets, t: "Gestion des liquidités" }, { icon: TrendingUp, t: "Capital entrepreneurial" },
  { icon: LineChart, t: "Stratégies de placement" }, { icon: Sunrise, t: "Planification de la retraite" },
  { icon: Users, t: "Fidélisation des employés" }, { icon: Layers, t: "Solutions collectives hybrides" },
];

const Cycle = () => {
  const steps = ["ASSURER", "PROTÉGER", "SOUTENIR"];
  return (
    <div className="relative mx-auto aspect-square w-full max-w-[420px]" data-testid="cycle-diagram">
      <svg viewBox="0 0 200 200" className="absolute inset-0 h-full w-full animate-[spin_40s_linear_infinite]" aria-hidden="true">
        <defs><marker id="arr" markerWidth="8" markerHeight="8" refX="4" refY="4" orient="auto"><path d="M0,0 L8,4 L0,8 z" fill="#650D23" /></marker></defs>
        {[0, 120, 240].map((a) => (
          <path key={a} d="M100 18 A82 82 0 0 1 171 59" fill="none" stroke="#650D23" strokeWidth="1.6" markerEnd="url(#arr)" transform={`rotate(${a} 100 100)`} />
        ))}
      </svg>
      <div className="absolute inset-[28%] flex flex-col items-center justify-center rounded-full bg-[#650D23] text-center text-[#FFFDFB]">
        <span className="font-display text-2xl leading-none">360°</span>
        <span className="mt-1 text-[10px] uppercase tracking-[0.2em] text-[#EDE3D9]">Collectif</span>
      </div>
      {steps.map((s, i) => {
        const pos = ["left-1/2 top-0 -translate-x-1/2", "right-0 bottom-[14%]", "left-0 bottom-[14%]"][i];
        return <span key={s} className={`absolute ${pos} rounded-full border border-[#EDE3D9] bg-[#FFFDFB] px-4 py-2 text-xs font-semibold tracking-[0.18em] text-[#650D23] shadow-sm`}>{s}</span>;
      })}
    </div>
  );
};

export default function Incorpores() {
  return (
    <PageFade>
      <PageHeader eyebrow="Plans pour les incorporés" title="Des stratégies financières" accent="à la hauteur de votre entreprise." image="/img/entrepreneur3.jpg">
        <p className="max-w-xl text-lg text-[#242020]/80">Pour les propriétaires de PME et de sociétés incorporées qui souhaitent protéger leur entreprise, leurs dirigeants et leur équipe.</p>
        <Link to="/secteurs" className="btn-primary" data-testid="inc-cta">EXPLORER LES SOLUTIONS POUR MON ENTREPRISE <ArrowRight className="h-4 w-4" /></Link>
      </PageHeader>
      <Container className="py-16 lg:py-24">
        <Reveal><h2 className="mb-10 text-3xl sm:text-4xl">Ce que nous explorons avec vous</h2></Reveal>
        <TopicGrid items={TOPICS} testid="inc-topics" />
      </Container>
      <section className="bg-[#FAF6F1]">
        <Container className="grid items-center gap-14 py-20 lg:grid-cols-2 lg:py-28">
          <Reveal className="overflow-hidden p-2"><Cycle /></Reveal>
          <Reveal delay={0.1} className="space-y-6">
            <p className="eyebrow">Remplacement collectif 360°</p>
            <h2 className="text-3xl sm:text-4xl">Assurer → Protéger → Soutenir</h2>
            <p className="text-lg leading-relaxed text-[#242020]/80">Une approche qui vise à soutenir les entrepreneurs et leurs équipes grâce à des solutions complémentaires de protection et d'accompagnement.</p>
            <div className="card-soft p-6" data-testid="fidelite-section">
              <h3 className="text-xl">Fidélité corporative et solutions hybrides</h3>
              <p className="mt-3 text-[.95rem] leading-relaxed text-[#242020]/75">Des solutions employeur-employé peuvent contribuer à reconnaître et à retenir les membres de votre équipe. Leur pertinence, leurs modalités et leur traitement fiscal varient selon chaque entreprise et doivent être évalués avec les professionnels appropriés.</p>
            </div>
            <Link to="/secteurs" className="btn-primary" data-testid="inc-cta-bottom">EXPLORER LES SOLUTIONS POUR MON ENTREPRISE <ArrowRight className="h-4 w-4" /></Link>
          </Reveal>
        </Container>
      </section>
      <ConsultationSection />
    </PageFade>
  );
}
